import {RecentAbstractView} from "./RecentAbstractView";

export class RecentMemberView extends RecentAbstractView {

    memberId: number;
    memberFirstName: string;
    memberLastName: string;
    memberCompanyName: string;
    memberUserGroupId: number;

    constructor(data?: any) {
        super(data);
        this.memberId = data?.memberId ?? -1;
        this.memberFirstName = data?.memberFirstName ?? "";
        this.memberLastName = data?.memberLastName ?? "";
        this.memberCompanyName = data?.memberCompanyName ?? "";
        this.memberUserGroupId = data?.memberUserGroupId ?? -1;
    }
}